import React from "react";
import styled from "styled-components";

export const ButtonStyle = styled.div`
    button {
        padding: 9px 16px;
        border-radius: 6px;
        font-weight: 500;
        display: flex;
        gap: 9px;
        align-items: center;
        text-transform: capitalize;
        margin: 4px;
        &.disabled {
            background-color: #8cc4d2;
            color: #fff;
            cursor: default;
        }
    }
`;
// choose from those types
// btnStyle=[primaryBtn , secondBtn]

function Button({ type, name, onChange, btnStyle, disabled, icon }) {
    return (
        <ButtonStyle>
            <button
                type={type}
                onClick={onChange}
                className={btnStyle}
                disabled={disabled}
                icon={icon}
            >
                {icon && icon}
                {name}
            </button>
        </ButtonStyle>
    );
}

export default Button;
